const Americaon2024_3=[
    {
        "Name": "chr1",
        "Length": 221461430
    },
    {
        "Name": "chr2",
        "Length": 115282544
    },
    {
        "Name": "chr3",
        "Length": 117411906
    },
    {
        "Name": "chr4",
        "Length": 101506117
    },
    {
        "Name": "chr5",
        "Length": 86824250
    },
    {
        "Name": "chr6",
        "Length": 73636471
    },
    {
        "Name": "chr7",
        "Length": 62419527
    },
    {
        "Name": "chr8",
        "Length": 59915000
    },
    // {
    //     "Name": "ptg000017l",
    //     "Length": 230693
    // },
    // {
    //     "Name": "ptg000029l",
    //     "Length": 196879
    // },
    // {
    //     "Name": "ptg000030l",
    //     "Length": 36869
    // },
    // {
    //     "Name": "ptg000031l",
    //     "Length": 43070
    // },
    // {
    //     "Name": "ptg000034l",
    //     "Length": 178326
    // },
    // {
    //     "Name": "ptg000036l",
    //     "Length": 63701
    // },
    // {
    //     "Name": "ptg000040l",
    //     "Length": 46303
    // },
    // {
    //     "Name": "ptg000041l",
    //     "Length": 67214
    // },
    // {
    //     "Name": "ptg000042l",
    //     "Length": 127301
    // },
    // {
    //     "Name": "ptg000043l",
    //     "Length": 97343
    // },
    // {
    //     "Name": "ptg000044l",
    //     "Length": 83594
    // },
    // {
    //     "Name": "ptg000048l",
    //     "Length": 83602
    // },
    // {
    //     "Name": "ptg000086l",
    //     "Length": 75810
    // },
    // {
    //     "Name": "ptg000088l",
    //     "Length": 215462
    // },
    // {
    //     "Name": "ptg000091l",
    //     "Length": 70357
    // },
    // {
    //     "Name": "ptg000092l",
    //     "Length": 36713
    // },
    // {
    //     "Name": "ptg000119l",
    //     "Length": 181794
    // },
    // {
    //     "Name": "ptg000120l",
    //     "Length": 70806
    // },
    // {
    //     "Name": "ptg000129l",
    //     "Length": 63421
    // },
    // {
    //     "Name": "ptg000130l",
    //     "Length": 54778
    // },
    // {
    //     "Name": "ptg000132l",
    //     "Length": 45579
    // },
    // {
    //     "Name": "ptg000134l",
    //     "Length": 64678
    // },
    // {
    //     "Name": "ptg000135l",
    //     "Length": 43059
    // },
    // {
    //     "Name": "ptg000139l",
    //     "Length": 119542
    // },
    // {
    //     "Name": "ptg000140l",
    //     "Length": 59356
    // },
    // {
    //     "Name": "ptg000150l",
    //     "Length": 50826
    // },
    // {
    //     "Name": "ptg000151l",
    //     "Length": 25534
    // },
    // {
    //     "Name": "ptg000160l",
    //     "Length": 94915
    // },
    // {
    //     "Name": "ptg000161l",
    //     "Length": 57745
    // },
    // {
    //     "Name": "ptg000162l",
    //     "Length": 57601
    // },
    // {
    //     "Name": "ptg000164l",
    //     "Length": 64005
    // },
    // {
    //     "Name": "ptg000168l",
    //     "Length": 65794
    // },
    // {
    //     "Name": "ptg000170l",
    //     "Length": 54720
    // }
]
export default Americaon2024_3